export const typePack = function (item = null) {
    return {
        id: item == null ? null : item.id,
        label: item == null ? null : item.label,
        packOrder: item == null ? null : parseInt(item.packOrder, 10),
        urlId: item == null || item['@id'] == undefined ? '' : item['@id'],
        isActive: item == null || item.isActive == undefined ? false : item.isActive,
        enabled: item == null || item.enabled == undefined ? false : item.enabled,
        deleted: item == null || item.enabled == undefined ? false : item.deleted
    };
};
